import requests from "./httpService";


const RazorpayOrderDetailsServices = {

 RazorpayOrderDetailsList: async () => {
  
    return requests.get(`/razpaydetails/order-details`);
  }


};

export default RazorpayOrderDetailsServices;
